<template>
  <div class="alfresco">
    <h1>Session Alfresco</h1>

    <div v-if="loggedIn">
      <p>Session active</p>
      <button type="button" class="btn btn-primary" @click="doLogout">Déconnexion</button>
    </div>

    <div v-else>
      <p>Session inactive</p>
      <input type="text" class="form-input" v-model="username">
      <input type="password" class="form-input" v-model="password">
      <button type="button" class="btn btn-primary" @click="doLogin(username, password)">Connexion</button>
    </div>

  </div>
</template>

<script>
import VueCookie from 'vue-cookie'

export default {
  name: 'alfresco',
  components: {
    VueCookie
  },
  data () {
    return {
      loggedIn: false,
      ticket: "",
      username: "",
      password: ""
    }
  },
  watch: {
    ticket: function(newValue) {
      if (/TICKET_[0-9a-f]{40}/.test(newValue)) {
        this.$cookie.set('ticket', this.ticket);
        this.loggedIn = true;
        this.$emit("input", { uploadUrl: `${this.serverAddress}/alfresco/service/saisie/newdoc?alf_ticket=${this.ticket}` });
        this.$emit("connected");
      } else {
        this.$cookie.delete('ticket');
        this.$cookie.delete('username');
        this.$cookie.delete('password');
        this.loggedIn = false;
        this.$emit("disconnected");
      }
    }
  },
  props: {
    value: {
      uploadUrl: `${this.serverAddress}/alfresco/service/saisie/newdoc`
    },
    serverAddress: {
      type: String,
      default: ""
    }
  },
  methods: {
    doLogin(username, password) {
      console.log("Do login!");

      axios.post(`${this.serverAddress}/alfresco/service/api/login`, {
        username: username,
        password: password
      })
        .then( (response) => {
          this.ticket = response.data.data.ticket;
          this.$cookie.set('username', username);
          this.$cookie.set('password', password);
          this.$emit('message', "Succès: doLogin()");
        })
        .catch( (error) => {
          this.$emit('message', "Une erreur s'est produite lors de la tentative de connexion.");
        });
    },
    doLogout() {
      console.log("Do logout!");

      axios.delete(`${this.serverAddress}/alfresco/service/api/login/ticket/${this.ticket}`, {
        auth: {
          username: this.username,
          password: this.password
        }
      })
        .then( (response) => {
          this.ticket = ""
          this.$emit('message', "Succès: doLogout()");
        })
        .catch( (error) => {
          this.$emit('message', "Une erreur s'est produite lors de la fermeture de session.");
        });
    },
    validateTicket(ticket, username, password) {
      console.log("Validate ticket");
      axios.get(`${this.serverAddress}/alfresco/service/api/login/ticket/${this.ticket}`, {
        auth: {
          username: username,
          password: password
        }
      })
        .then( (response) => {
          this.ticket = ticket;
          this.$cookie.set('ticket', this.ticket);
          this.loggedIn = true;
          this.$emit('message', "Succès: validateTicket()");
        })
        .catch( (error) => {
          if (error.response) {
            console.log(error.response)
            switch(error.response.status) {
              case 401:
                this.$emit('message', "Accès interdit: validateTicket()");
                break;
              default:
                this.$emit('message', "Une erreur générale s'est produite lors de la validation du ticket...");
            }
          } else {
            this.$emit('message', "Une erreur générale s'est produite lors de la validation du ticket...");
          }
          this.ticket = "";
        });
    }
  },
  created: function() {
    console.log("Created!");
    if ( this.$cookie.get('ticket') && this.$cookie.get('username') && this.$cookie.get('password') ) {
      this.validateTicket(this.$cookie.get('ticket'), this.$cookie.get('password'), this.$cookie.get('password'));
    } else {
      console.log("No cookies :(");
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// alfresco.vue?268c6861